import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { bind } from '../../utils/decorators';
import { FormControl } from 'react-bootstrap';

/** Basisklasse für Listen die Daten paginiert und gefiltert vom Back-End abrufen */
@observer
export default class PagedList<P> extends React.Component<P> {
  // Pagination und Filterung
  @observable currentPage: number = 1;
  @observable lastPage: number = 1;
  @observable filter: string = '';
  total: number = 1;
  protected filterDelay: number = 150;

  paginate?(pageNumber: number): void;

  @action setLastPage(value: number) {
    this.lastPage = value;
  }

  @action setFilter(value: string) {
    this.filter = value;
  }

  @action setCurrentPage(value: number) {
    this.currentPage = value;
  }

  @action setTotal(value: number) {
    this.total = value;
  }

  @bind @action handleFilterList(event: React.FormEvent<FormControl>) {
    this.setFilter((event.target as HTMLInputElement).value);
    if (this.filterDelay > 0) {
      window.clearTimeout(this.filterDelay);
      this.filterDelay = 0;
    }
    this.filterDelay = window.setTimeout(() => { if (this.paginate) { this.paginate(1); } }, 500);
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/PagedList.tsx